import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eywdt5usqy: FaireBrandEntity = {
  token: "b_eywdt5usqy",
  type: "brand",
  name: "BYBBA",
  avatarUrl: "https://cdn.faire.com/fastly/27dc0d711d4d3f4b92d04fe22345edc746523950498be4266ef637c2955971b8.png",
  bannerUrl: "https://cdn.faire.com/fastly/1b09de88cfe4d0591b225a720561c9508d8e6cd6100caeaa80774b2e79ae26be.png",
  logoUrl: "https://cdn.faire.com/fastly/27dc0d711d4d3f4b92d04fe22345edc746523950498be4266ef637c2955971b8.png",
  heroImageUrl: "https://cdn.faire.com/fastly/1b09de88cfe4d0591b225a720561c9508d8e6cd6100caeaa80774b2e79ae26be.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 200,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description: "BYBBA brings quality, style, and sustainability together. We’re on a mission to create products that allow you to do more with less as we turn ocean plastic into bags that are made to last, designed for everyday adventures and packed with purpose- every bag sold funds the removal of one pound of plastic from oceans, rivers, and coastlines through our partnership with 4OCEAN.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:04.406Z",
    importedBy: "entity-db-cli"
  }
};
